<template>
  <v-app>
    <elder-header/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>


  import ElderHeader from "@/components/Native/Elder/ElderDashboard/ElderHeader";
  export default {
    name: 'App',
    components: {
      ElderHeader

    }
  }
</script>

<style>
  #app{
    font-family: IBM Plex Sans, serif !important;
  }
  .transformModal {
    transform: translateX(450px) !important;
    /*margin-right: -5px !important;*/
  }
  body{
    font-family: IBM Plex Sans,serif !important;
    background: #F6F6F6;
  }
</style>
